import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import { resolveAll } from '../helpers/LinkMapper';

import Fare from "../records/Fare";

const FareOnlyService = {

    /**
     * @param {Search} search
     * @return {Fare[]}
     */
    async search (search) {
        const response = await AuthenticatedAPIClient.post(`/jp/tickets/fare-only`, search.toFareOnlyJSON());
        return resolveAll(response.result).as(Fare);
    },

    /**
     * @param {SeasonSearch} search
     * @return {Fare[]}
     */
    async seasonSearch (search) {
        const response = await AuthenticatedAPIClient.post(`/jp/season-tickets/fare-only`, search.toFareOnlyJSON());
        return resolveAll(response.result).as(Fare);
    }
};

export default FareOnlyService;
